// PutyovkaFormModal.js
import React, {useState, useEffect, useRef} from 'react';
import {Button, Form, Modal, Row, Col} from 'react-bootstrap';
import ShafyorService from '../services/ShafyorService';
import PrisepsService from '../services/PrisepsService';
import {FaPlus} from "react-icons/fa";
import TransportService from "../services/TransportService";
import {formatCurrency} from "../utils/formatters";

const PutyovkaFormModal = ({show, onHide, onSave, formData, setFormData, transportId, isEdit}) => {

    const defaultFormData = {
        id: '',
        transport_id: '',
        raqam: '',
        narx: '',
        dan: '',
        gacha: '',
        shafyors: [],
        putyofka_priseps: [],
        putyofka_yonalishs: []
    };
    formData = formData || defaultFormData;
    const handleClose = () => {
        setFormData(defaultFormData); // formani tozalash
        setSelectedShafyor(null);
        setSelectedPrisep(null);
        setFilteredShafyorlar([]);
        setFilteredPrisepslar([]);
        setShafyorSearch('');
        setPrisepsSearch('');
        onHide(); // modalni yopish
    };


    const [shafyorSearch, setShafyorSearch] = useState('');
    const [filteredShafyorlar, setFilteredShafyorlar] = useState([]);

    const [prisepsSearch, setPrisepsSearch] = useState();
    const [filteredPrisepslar, setFilteredPrisepslar] = useState([]);

    // trasport uchun combo ----------------------------------------------------------------------------------------------------
    const [transportList, setTransportList] = useState([]);
    const [filteredTransports, setFilteredTransports] = useState([]);
    const [showCombo, setShowCombo] = useState(false);
    const [selectedTransport, setSelectedTransport] = useState(null);

    // priseps uchun combo ----------------------------------------------------------------------------------------------------
    const [prisepsList, setPrisepsList] = useState([]);

    useEffect(() => {
        const fetchShafyorlar = async () => {
            const res = await ShafyorService.searchByName(shafyorSearch);
            setFilteredShafyorlar(res.data);
        };
        if (shafyorSearch) {
            fetchShafyorlar();
        } else {
            setFilteredShafyorlar([]);
        }
    }, [shafyorSearch]);

    useEffect(() => {
        const fetchPrisepslar = async () => {
            const res = await PrisepsService.searchByName(prisepsSearch);
            console.log(res.data);
            setFilteredPrisepslar(res.data);
        };
        if (prisepsSearch) {
            fetchPrisepslar();
        } else {
            setFilteredPrisepslar([]);
        }

    }, [prisepsSearch]);

    useEffect(() => {
        if (formData.putyofka_yonalishs.length === 0) {
            setFormData({
                ...formData,
                putyofka_yonalishs: [{from_davlat: '', to_davlat: ''}, {from_davlat: '', to_davlat: ''}]
            });
        }

        if (formData.shafyors){
            setFilteredShafyorlar(formData.shafyors);
        }
    }, []);

    useEffect(() => {
        const fetchTransports = async () => {
            try {
                const resp = await TransportService.getTransportList();
                setTransportList(resp.data); // agar resp.data array bo‘lsa
            } catch (e) {
                console.error('Transport load error', e);
            }
        };

        if (!transportId) {
            fetchTransports();
        }

    }, []);

    const [selectedShafyor, setSelectedShafyor] = useState(null);

    // const handleAddShafyor = (shafyor) => {
    //     setSelectedShafyor(shafyor);
    //     const newShafyor = shafyor || {name: shafyorSearch, prava_raqam: '', phone: ''};
    //     setFormData({
    //         ...formData,
    //         shafyors: [...formData.shafyors, newShafyor],
    //     });
    //     setShafyorSearch('');
    //     setFilteredShafyorlar([]);
    // };

    const handleAddShafyor = (shafyor) => {
        setSelectedShafyor(shafyor);

        const newShafyor = shafyor
            ? {
                name: shafyor.name,
                phone: shafyor.phone,
                prava_raqam: shafyor.prava_raqam,
                shafyor: shafyor  // optional: backendga yuborish uchun to‘liq object saqlab qo‘yamiz
            }
            : {
                name: shafyorSearch,
                phone: '',
                prava_raqam: '',
                shafyor: null
            };

        setFormData(prev => ({
            ...prev,
            shafyors: [...prev.shafyors, newShafyor]
        }));

        setShafyorSearch('');
        setFilteredShafyorlar([]);
    };

    const comboRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (comboRef.current && !comboRef.current.contains(event.target)) {
                setFilteredShafyorlar([]); // combo'ni yopish
                setFilteredPrisepslar([]);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleShafyorChange = (index, field, value) => {
        const updated = [...formData.shafyors];
        updated[index][field] = value;
        setFormData({...formData, shafyors: updated});
    };

    const removeShafyor = (index) => {
        const updated = [...formData.shafyors];
        updated.splice(index, 1);
        setFormData({...formData, shafyors: updated});
    };

    const [selectedPrisep, setSelectedPrisep] = useState(null);
    // const handleAddPriseps = (priseps) => {
    //     setSelectedPrisep(priseps);
    //     const newPriseps = priseps || {
    //         name: prisepsSearch,
    //         davlat_raqam: '',
    //         tex_passport_raqam: '',
    //         rang: '',
    //         izoh: ''
    //     };
    //     setFormData({
    //         ...formData,
    //         putyofka_priseps: [...formData.putyofka_priseps, newPriseps],
    //     });
    //     setPrisepsSearch('');
    //     setFilteredPrisepslar([]);
    // };

    const handleAddPriseps = (priseps) => {
        setSelectedPrisep(priseps);

        const newPriseps = priseps
            ? {
                name: priseps.name,
                davlat_raqam: priseps.davlat_raqam,
                tex_passport_raqam: priseps.tex_passport_raqam,
                rang: priseps.rang,
                izoh: priseps.izoh || '',
                transport: priseps // to‘liq objectni saqlab qo‘yish (ixtiyoriy, backend uchun foydali)
            }
            : {
                name: prisepsSearch,
                davlat_raqam: '',
                tex_passport_raqam: '',
                rang: '',
                izoh: '',
                transport: null
            };

        setFormData(prev => ({
            ...prev,
            putyofka_priseps: [...prev.putyofka_priseps, newPriseps]
        }));

        setPrisepsSearch('');
        setFilteredPrisepslar([]);
    };

    const handlePrisepsChange = (index, field, value) => {
        const updated = [...formData.putyofka_priseps];
        updated[index][field] = value;
        setFormData({...formData, putyofka_priseps: updated});
    };

    const removePriseps = (index) => {
        const updated = [...formData.putyofka_priseps];
        updated.splice(index, 1);
        setFormData({...formData, putyofka_priseps: updated});
    };

    const handleAddYonalish = () => {
        setFormData({
            ...formData,
            putyofka_yonalishs: [...formData.putyofka_yonalishs, {from_davlat: '', to_davlat: ''}],
        });
    };

    const handleYonalishChange = (index, field, value) => {
        const updated = [...formData.putyofka_yonalishs];
        updated[index][field] = value;
        setFormData({...formData, putyofka_yonalishs: updated});
    };

    const removeYonalish = (index) => {
        const updated = [...formData.putyofka_yonalishs];
        updated.splice(index, 1);
        setFormData({...formData, putyofka_yonalishs: updated});
    };

    //transport
    const handleTransportInput = (e) => {
        const val = e.target.value;
        setFormData({...formData, transportNumber: val});
        console.log('filtered transports', filteredTransports);
        const filtered = transportList.filter(t =>
            t.davlat_raqam.toLowerCase().includes(val.toLowerCase())
        );
        setFilteredTransports(filtered);
        setShowCombo(true);
    };

    const selectTransport = (val, id, item) => {
        setSelectedTransport(item);
        setFormData({...formData, transportNumber: val, transport_id: id});
        setShowCombo(false);
    };

    const handleSummaChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        setFormData(prev => ({
            ...prev,
            narx: value ? formatCurrency(parseInt(value)) : ''
        }));
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered style={{zIndex: 2000}}>
            <Modal.Header closeButton>
                <Modal.Title>Putyovka qo‘shish / tahrirlash</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {/* Transpo izlash */}
                    <div style={{backgroundColor: 'whitesmoke', padding: '10px', marginBottom: '10px'}}>
                        {!transportId && (
                            <Form.Group className="mb-3" style={{position: 'relative'}}>
                                <Form.Label className=' font-weight-bold'>Transport raqami</Form.Label>
                                <Form.Control
                                    type="text"
                                    autoComplete="off"
                                    value={formData.transportNumber}
                                    onChange={handleTransportInput}
                                    placeholder="Masalan: 01 A 234 BC"
                                    onFocus={() => setShowCombo(true)}
                                />
                                {showCombo && filteredTransports && filteredTransports.length > 0 && (
                                    <div
                                        className="border position-absolute w-100 shadow-sm pb-1"
                                        style={{
                                            zIndex: 10,
                                            maxHeight: '180px',
                                            overflowY: 'auto',
                                            backgroundColor: 'whitesmoke'
                                        }}
                                    >
                                        {filteredTransports.map((t) => {
                                            const isSelected = t.davlat_raqam === formData.transportNumber;
                                            return (
                                                <div
                                                    key={t.id}
                                                    className={`px-2 py-1 selectable-item ${isSelected ? 'selected' : ''}`}
                                                    onClick={() => selectTransport(t.davlat_raqam, t.id, t)}
                                                >
                                                    {t.davlat_raqam}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </Form.Group>
                        )}
                        <Form.Group className="mb-3"><Form.Label>Putyovka raqami</Form.Label>
                            <Form.Control value={formData.raqam}
                                          onChange={e => setFormData({...formData, raqam: e.target.value})}/>
                        </Form.Group>
                        <Row>
                            <Col><Form.Group className="mb-3"><Form.Label>Boshlanish sanasi</Form.Label>
                                <Form.Control type="date" value={formData.dan} onChange={e => setFormData({
                                    ...formData,
                                    dan: e.target.value
                                })}/></Form.Group></Col>
                            <Col><Form.Group className="mb-3"><Form.Label>Tugash sanasi</Form.Label>
                                <Form.Control type="date" value={formData.gacha} onChange={e => setFormData({
                                    ...formData,
                                    gacha: e.target.value
                                })}/></Form.Group></Col>
                        </Row>
                        <Form.Group className="mb-3"><Form.Label>Narx</Form.Label>
                            {/*<Form.Control type="number" value={formData.narx} onChange={e => setFormData({*/}
                            {/*    ...formData,*/}
                            {/*    narx: e.target.value*/}
                            {/*})}/>*/}
                            <Form.Control
                                type="text"
                                name="summa"
                                value={formData.narx}
                                onChange={handleSummaChange}
                                placeholder="0"
                                required
                                disabled={false}
                            />
                        </Form.Group>
                        {/*<Form.Group className="mb-3"><Form.Label>Izoh</Form.Label>*/}
                        {/*    <Form.Control as="textarea" rows={2} value={formData.izoh} onChange={e => setFormData({ ...formData, izoh: e.target.value })} /></Form.Group>*/}
                        {/*<Form.Group className="mb-3"><Form.Label>Fayl</Form.Label>*/}
                        {/*    <Form.Control type="file" onChange={e => setFormData({ ...formData, fayl: e.target.files[0] })} /></Form.Group>*/}
                    </div>

                    {/* Haydovchi izlash */}
                    <div className="mb-3 mt-5"
                         style={{backgroundColor: 'whitesmoke', borderRadius: '5px', padding: '10px'}}>
                        <Form.Group className='mb-3' style={{backgroundColor: 'whitesmoke', borderRadius: '5px'}}>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <Form.Label className="mb-0 font-weight-bold">Haydovchi Qo‘shish</Form.Label>
                                <Button style={{
                                    width: '25px',
                                    height: '25px',
                                    padding: '0',
                                    backgroundColor: 'green',
                                    margin: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }} onClick={() => handleAddShafyor(null)}><FaPlus
                                    style={{color: 'white', height: '12px', width: '12px'}}/></Button>
                            </div>
                            <Form.Control
                                type="text"
                                value={shafyorSearch}
                                onChange={e => setShafyorSearch(e.target.value)}
                                placeholder="izlang..."
                            />
                            {filteredShafyorlar && filteredShafyorlar.length > 0 && (
                                <div
                                    className="border bg-white shadow-sm mt-1 position-relative"
                                    style={{maxHeight: '210px', overflowY: 'auto'}} // 7 ta * 30px (taxminiy)
                                    ref={comboRef}
                                >
                                    {filteredShafyorlar.map((s, index) => (
                                        <div
                                            style={{backgroundColor: 'white', cursor: 'grab'}}
                                            key={s.id}
                                            className={`p-2 ${
                                                selectedShafyor?.id === s.id ? 'bg-primary text-white' : 'hover:bg-light'
                                            }`}
                                            onClick={() => handleAddShafyor(s)}
                                        >
                                            {s.name} ({s.phone})
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Form.Group>

                        {formData.shafyors.map((shafyor, index) => (
                            <div key={index} className="border p-3 rounded mb-3"
                                 style={{backgroundColor: 'whitesmoke'}}>
                                <Row>
                                    <Col md={4}><Form.Label>Ism</Form.Label>
                                        <Form.Control value={shafyor.shafyor?.name}
                                                      onChange={e => handleShafyorChange(index, 'name', e.target.value)}/></Col>
                                    <Col md={4}><Form.Label>Prava raqam</Form.Label>
                                        <Form.Control value={shafyor.shafyor?.prava_raqam}
                                                      onChange={e => handleShafyorChange(index, 'prava_raqam', e.target.value)}/></Col>
                                    <Col md={3}><Form.Label>Telefon</Form.Label>
                                        <Form.Control value={shafyor.shafyor?.phone}
                                                      onChange={e => handleShafyorChange(index, 'phone', e.target.value)}/></Col>
                                    <Col md={1} className="d-flex align-items-end">
                                        <Button variant="danger" size="sm"
                                                onClick={() => removeShafyor(index)}>-</Button>
                                    </Col>
                                </Row>
                            </div>
                        ))}
                    </div>

                    {/* Priseps izlash */}
                    <div className="mb-3 mt-5"
                         style={{backgroundColor: 'whitesmoke', borderRadius: '5px', padding: '10px'}}>
                        <Form.Group className='mb-3' style={{backgroundColor: 'whitesmoke', borderRadius: '5px'}}>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <Form.Label className="mb-0 font-weight-bold">Prisep Qo'shish</Form.Label>
                                <Button style={{
                                    width: '25px',
                                    height: '25px',
                                    padding: '0',
                                    backgroundColor: 'green',
                                    margin: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }} onClick={() => handleAddPriseps(null)}><FaPlus
                                    style={{color: 'white', height: '12px', width: '12px'}}/></Button>
                            </div>
                            <Form.Control
                                type="text"
                                value={prisepsSearch}
                                onChange={e => setPrisepsSearch(e.target.value)}
                                placeholder="izlang..."

                                // value={formData.transportNumber}
                                // onChange={handleTransportInput}
                                // placeholder="Masalan: 01 A 234 BC"
                                // onFocus={() => setShowCombo(true)}
                            />
                            {filteredPrisepslar && filteredPrisepslar.length > 0 && (
                                <div className="border bg-white shadow-sm mt-1 position-relative"
                                     style={{maxHeight: '210px', overflowY: 'auto'}} // 7 ta * 30px (taxminiy)
                                     ref={comboRef}>
                                    {filteredPrisepslar.map(p => (
                                        <div
                                            key={p.id}
                                            style={{cursor: 'grab'}}
                                            className={`p-2 cursor-grab ${
                                                selectedPrisep?.id === p.id ? 'bg-primary text-white' : 'hover:bg-light'
                                            }`}
                                            onClick={() => handleAddPriseps(p)}
                                        >
                                            {p.name} ({p.davlat_raqam})
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Form.Group>

                        {formData.putyofka_priseps.map((priseps, index) => (
                            <div key={index} className="border p-3 rounded mb-3"
                                 style={{backgroundColor: 'whitesmoke'}}>
                                <Row>
                                    <Col md={3}><Form.Label>Davlat raqami</Form.Label>
                                        <Form.Control value={priseps.transport?.davlat_raqam}
                                                      onChange={e => handlePrisepsChange(index, 'davlat_raqam', e.target.value)}/></Col>
                                    <Col md={3}><Form.Label>Tex pasport raqami</Form.Label>
                                        <Form.Control value={priseps.transport?.tex_passport_raqam}
                                                      onChange={e => handlePrisepsChange(index, 'tex_passport_raqam', e.target.value)}/></Col>
                                    <Col md={3}><Form.Label>Rang</Form.Label>
                                        <Form.Control value={priseps.transport?.rang}
                                                      onChange={e => handlePrisepsChange(index, 'rang', e.target.value)}/></Col>
                                    <Col md={2}><Form.Label>Izoh</Form.Label>
                                        <Form.Control value={priseps.transport?.izoh}
                                                      onChange={e => handlePrisepsChange(index, 'izoh', e.target.value)}/></Col>
                                    <Col md={1} className="d-flex align-items-end">
                                        <Button variant="danger" size="sm"
                                                onClick={() => removePriseps(index)}>-</Button>
                                    </Col>
                                </Row>
                            </div>
                        ))}
                    </div>

                    {/* Yo'nalishlar */}
                    <div className="mt-5" style={{backgroundColor: 'whitesmoke', borderRadius: '5px', padding: '10px'}}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <Form.Label className="mb-0 font-weight-bold">Yo‘nalishlar</Form.Label>
                            <Button style={{
                                width: '25px',
                                height: '25px',
                                padding: '0',
                                backgroundColor: 'green',
                                margin: '0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }} onClick={handleAddYonalish}><FaPlus
                                style={{color: 'white', height: '12px', width: '12px'}}/></Button>
                        </div>
                        {formData.putyofka_yonalishs.map((yon, index) => (
                            <div key={index} className="border p-3 rounded mb-3">
                                <Row>
                                    <Col><Form.Label>From</Form.Label>
                                        <Form.Control value={yon.from_davlat}
                                                      onChange={e => handleYonalishChange(index, 'from_davlat', e.target.value)}/></Col>
                                    <Col><Form.Label>To</Form.Label>
                                        <Form.Control value={yon.to_davlat}
                                                      onChange={e => handleYonalishChange(index, 'to_davlat', e.target.value)}/></Col>
                                    <Col md={1} className="d-flex align-items-end">
                                        <Button variant="danger" size="sm"
                                                onClick={() => removeYonalish(index)}>-</Button>
                                    </Col>
                                </Row>
                            </div>
                        ))}
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Bekor qilish</Button>
                <Button variant="primary" onClick={onSave}>Saqlash</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PutyovkaFormModal;
